import { motion } from "framer-motion";
import { MessageSquareLock, PhoneCall, FileCheck2, Sparkles } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { EASE } from "./data";

const STEPS = [
  { icon: MessageSquareLock, t: "Bizalmas kapcsolatfelvétel", d: "Űrlapon, telefonon vagy WhatsAppon – akár álnévvel is." },
  { icon: PhoneCall, t: "Visszahívás 1 órán belül", d: "Átbeszéljük a helyzetet, és egyeztetjük a felmérést." },
  { icon: FileCheck2, t: "Fix áras, írásos ajánlat", d: "Rejtett költségek nélkül, előre rögzített végösszeggel." },
  { icon: Sparkles, t: "Diszkrét kivitelezés & átadás", d: "Jelzés nélküli autókkal érkezünk, tiszta ingatlant adunk át." },
];

export const Process = () => (
  <section id="folyamat" data-testid="process-section" className="py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-3xl">
        <Eyebrow>Így dolgozunk</Eyebrow>
        <h2 className="font-display mt-5 text-3xl font-black leading-[1.05] tracking-tight text-[var(--navy)] sm:text-5xl">Négy egyszerű lépés. Semmi meglepetés.</h2>
      </Reveal>
      <div className="relative mt-14">
        <div className="absolute left-0 right-0 top-[42px] hidden h-px bg-[var(--navy)]/15 lg:block">
          <motion.div
            className="h-full origin-left bg-[var(--crimson)]"
            initial={{ scaleX: 0 }}
            whileInView={{ scaleX: 1 }}
            viewport={{ once: true, amount: 0.5 }}
            transition={{ duration: 1.6, ease: EASE }}
          />
        </div>
        <ol className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((s, i) => (
            <Reveal as="li" key={s.t} delay={i * 0.1} className="relative">
              <div data-testid={`process-step-${i + 1}`} className="group h-full rounded-[22px] border border-[var(--navy)]/10 bg-white p-6 transition-shadow duration-500 hover:shadow-[0_20px_40px_-20px_rgba(15,42,74,0.35)]">
                <div className="flex items-center justify-between">
                  <span className="relative z-10 flex h-[54px] w-[54px] items-center justify-center rounded-full bg-[var(--navy)] text-white ring-8 ring-[var(--ivory)] transition-transform duration-500 group-hover:rotate-[-8deg]">
                    <s.icon className="h-6 w-6" />
                  </span>
                  <span className="font-display text-5xl font-black text-[var(--navy)]/10">{i + 1}</span>
                </div>
                <h3 className="font-display mt-6 text-xl font-extrabold text-[var(--navy)]">{s.t}</h3>
                <p className="mt-2 text-[15px] leading-relaxed text-[var(--muted)]">{s.d}</p>
              </div>
            </Reveal>
          ))}
        </ol>
      </div>
    </div>
  </section>
);
